import $ from 'jquery';
import Cache from 'root/cache';
import UI from 'root/ui';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'workspace-invite-link',

    events: {
        'click .link-container'               : 'onSelectUrl',
        'click .invite-link-reset'            : 'onResetInviteLink',
        'click .dropdown-join-project-ids li' : 'onToggleJoinProjectIds'
    },

    dom_handlers: {
        onSelectUrl: function(e) {
            try {
                var range = document.createRange();
                range.selectNode(this.$el.find('.url').get(0));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);

                Util.copyText(this.$el.find('.url').text(), () => {
                    UI.success('Invite link copied');
                });
            } catch (e) {
            }
        },

        onResetInviteLink: function(e) {
            e.preventDefault();
            Modals.resetWorkspaceJoinCode();
        },

        onToggleJoinProjectIds: function(e) {
            var project_id = parseInt($(e.currentTarget).data('val'), 10);
            var join_project_ids = [];

            if (this.model.get('join_project_ids')) {
                this.model.get('join_project_ids').split(',').forEach((project_id) => {
                    join_project_ids.push(parseInt(project_id.trim(), 10));
                });
            }

            if (join_project_ids.indexOf(project_id) === -1) {
                join_project_ids.push(project_id);
            } else {
                join_project_ids.splice(join_project_ids.indexOf(project_id), 1);
            }

            Cache.app.request({
                action: 'workspace/update',
                data: {
                    workspace_id: this.model.id,
                    join_project_ids: join_project_ids.join(',')
                },
                success: (e) => {
                    this.model.set('join_project_ids', join_project_ids.join(','));
                    UI.success('Default projects updated');
                }
            });
        }
    },

    initialize: function() {
        this.listenTo(Cache.getDefaultWorkspace(), 'change:join_code',        this.render);
        this.listenTo(Cache.getDefaultWorkspace(), 'change:join_project_ids', this.render);
    },

    render: function() {
        var content = '';

        var join_project_ids = [];

        if (this.model.get('join_project_ids')) {
            this.model.get('join_project_ids').split(',').forEach((project_id) => {
                join_project_ids.push(parseInt(project_id.trim(), 10));
            });
        }

        var total_projects = 0;
        var project_options = '';
        Cache.project.where({is_archived: false}).forEach((project_model) => {
            var is_selected = join_project_ids.indexOf(project_model.id) !== -1;

            if (is_selected) {
                total_projects++;
            }

            project_options +=
            '<li data-val="' + project_model.id + '"' + (is_selected ? ' class="selected"' : '') + '>' +
                '<div class="flex-start">' +
                    (project_model.get('logo') ?
                    '<span class="project-logo-icon-tiny" style="background-image:url(' + project_model.escape('logo') + ');"></span>' :
                    '<span class="project-type-icon-tiny" data-val="' + (project_model.isFeedback() ? 'feedback' : 'survey') +'"></span>') +
                    '<span class="ellipsis margin-left-8">' + project_model.escape('name') + '</span>' +
                '</div>' +
            '</li>';
        });

        var content =
        '<p>Share this secret link to invite people to this workspace. When people join via the link they will have access to the selected projects. You can always <a class="invite-link-reset primary font-weight-medium" href="#">reset the link</a> to generate a new invite link.</p>' +

        (Cache.account.hasFeature('user_restriction') ?
        '<div class="form-fluid margin-bottom-24">' +
            '<div class="row">' +
                '<div class="field-label">' +
                    '<div>Default Projects:</div>' +
                '</div>' +
                '<div class="text-info text-medium margin-bottom-12">When people join via the link they will have access to the selected projects</div>' +
                '<div class="button-dropdown button-dropdown-left button-dropdown-xlarge">' +
                    '<button type="button" class="dropdown-select">' + total_projects + ' Project' + (total_projects === 1 ? '' : 's') + '</button>' +
                    '<div>' +
                        (Cache.project.where({is_archived: false}).length >= 10 ?
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search by project name">' +
                        '</div>' : '') +
                        (project_options ?
                        '<ul class="dropdown dropdown-select dropdown-join-project-ids">' +
                            project_options +
                        '</ul>' :
                        '<ul class="dropdown"><li class="disabled">No projects</li></ul>') +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' : '') +

        '<div class="link-container">' +
            '<div class="header">Invite Link:</div>' +
            '<div class="flex-between">' +
                '<div class="url"><div>' + this.model.getUrl() + '/join/' + this.model.get('join_code') + '/</div></div>' +
                '<span class="text-info"><i class="fa-solid fa-clone"></i></span>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});